// Dependency-free gold confetti burst on win (best-practice §11.7). GPU-cheap,
// respects prefers-reduced-motion.
const COLORS = ['#f2b705', '#ffd84d', '#e60012', '#16130e', '#ffffff'];

export function fireConfetti() {
  if (window.matchMedia?.('(prefers-reduced-motion: reduce)').matches) return;

  const canvas = document.createElement('canvas');
  canvas.style.cssText =
    'position:fixed;inset:0;width:100%;height:100%;pointer-events:none;z-index:2000';
  document.body.appendChild(canvas);
  const ctx = canvas.getContext('2d')!;
  const dpr = Math.min(window.devicePixelRatio || 1, 2);
  const W = (canvas.width = window.innerWidth * dpr);
  const H = (canvas.height = window.innerHeight * dpr);

  const N = 140;
  const parts = Array.from({ length: N }, (_, i) => ({
    x: W / 2 + (Math.sin(i) * W) / 6,
    y: H / 3,
    vx: (((i * 37) % 100) / 100 - 0.5) * 16 * dpr,
    vy: (-8 - ((i * 13) % 70) / 10) * dpr,
    s: (5 + ((i * 7) % 7)) * dpr,
    rot: (i % 360) * 0.0174,
    vr: ((i % 10) - 5) * 0.04,
    c: COLORS[i % COLORS.length],
  }));

  const g = 0.35 * dpr;
  let frame = 0;
  function tick() {
    ctx.clearRect(0, 0, W, H);
    frame++;
    for (const p of parts) {
      p.vy += g;
      p.x += p.vx;
      p.y += p.vy;
      p.vx *= 0.99;
      p.rot += p.vr;
      ctx.save();
      ctx.translate(p.x, p.y);
      ctx.rotate(p.rot);
      ctx.fillStyle = p.c;
      ctx.fillRect(-p.s / 2, -p.s / 2, p.s, p.s * 0.6);
      ctx.restore();
    }
    if (frame < 160) requestAnimationFrame(tick);
    else canvas.remove();
  }
  requestAnimationFrame(tick);
}
